import { Component, OnInit } from '@angular/core';
import { PI_VERSION, PrivacyLink } from '../../constants-types/constants';
import { IconSize } from '../../core-data-model/IconSize';
import { IconType } from '../../core-data-model/IconType';
import { Person } from '../../core-data-model/Person.model';
import { AuthenticationService } from '../../core-services/Authentication.service';
import { SelfIdentityDataService } from '../../core-services/SelfIdentity.dataservice';
import { UserProfileSettingsService } from '../../system-services';
import { InitDataService } from '../../system-services/InitData/InitData.service';
import { Logger } from '../../system-services/Logger/Logger.service';
import { TranslationService } from '../../translations/Translation.service';
import { MyBaService } from '../my-ba-profile/my-ba.service';
import { MyProfileTooltipService } from './my-profile-tooltip.service';

@Component({
    selector: 'my-profile-tooltip',
    templateUrl: 'my-profile-tooltip.component.html',
    styleUrls: ['./my-profile-tooltip.less'],
    standalone: false
})
export class MyProfileTooltipComponent implements OnInit {
    isLoading = true;
    isThirdPartyUser: boolean;

    IconType = IconType;
    IconSize = IconSize;
    // List of tabs
    navTabs = ['My Profile'];
    currentTab: string = this.navTabs[0]; // We start with My Profile tab as the default

    PrivacyLink = PrivacyLink;
    reportDownloadInProgress = false;

    constructor(
        private auth: AuthenticationService,
        public initData: InitDataService,
        public TR: TranslationService,
        public selfIdentityService: SelfIdentityDataService,
        private myProfileTooltipService: MyProfileTooltipService,
        private logger: Logger,
        private myBAService: MyBaService,
        private userProfileSettingsService: UserProfileSettingsService
    ) {}

    get self(): Person {
        return this.myProfileTooltipService.person;
    }

    get showMe(): boolean {
        return !!this.self?.referencePattern;
    }

    get showTabNavigation() {
        return (
            this.myBAService.hasViewedProfileCover() ||
            !this.self?.referencePattern
        );
    }

    get showProfile() {
        return this.myProfileTooltipService.showProfile;
    }

    get showBaReportsTab() {
        return this.isThirdPartyUser;
    }

    async ngOnInit() {
        await this.myProfileTooltipService.determineAssessmentState();
        this.isThirdPartyUser =
            !this.userProfileSettingsService.isUserLoggedInDefaultCompany();

        // Conditionally create the second tab
        if (this.showBaReportsTab) {
            this.navTabs.push(this.TR.key('userProfile.baReports.tab.title'));
        }
    }

    toggleProfileVisibility() {
        this.myProfileTooltipService.toggleVisibility();
        this.logger.logInfo(
            `MyProfileTooltip - BA experience profile tooltip ${
                this.showProfile ? 'opened' : 'closed'
            }`,
            {
                userId: this.initData.user.userId,
                email: this.initData.user.email,
                companyId: this.initData.user.companyId
            }
        );
    }

    focusLost() {
        // We need to worry about the focusLost only when the my-profile is currently displayed
        if (this.showProfile) {
            // Make the tooltip remain open when a BA download is requested
            if (!this.reportDownloadInProgress) {
                this.myProfileTooltipService.setTooltipVisibility(false);
            }
            this.reportDownloadInProgress = false;
        }
    }

    logout() {
        this.auth.logout();
    }

    getPiVersion(): string {
        return `${this.TR.key('footer.version')} ${PI_VERSION}`;
    }

    navigateToTabSection(selectedNavChoice: string): void {
        this.currentTab = selectedNavChoice;
    }

    highlightTab(navTab: string): boolean {
        return navTab === this.currentTab;
    }

    closeTooltip() {
        this.myProfileTooltipService.setTooltipVisibility(false);
    }
}
